
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { approveRegisterDraft } from "../../../features/admin3/admin3Slice"
import InputTextarea from "../../shared/input/new/InputTextarea"
import { showModal } from "../../../features/modal/modalSlice"
import Btn from "../../shared/button/Btn"
import { useScrollLock } from "../../../hooks/useScrollLock"
import SmallSpinner from "../../shared/spinners/SmallSpinner"

const Container = styled.div`

    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 600px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        p{
            font-size: 15px;
            font-weight: var(--font-weight-lg);
            color: ${({ theme }) => theme.mainTextColor};
            padding: 10px 60px 40px;
            line-height: 1.4;
            text-align: center;
            
            .red{
              color: var(--color-main);
              font-weight: var(--font-weight-xl);
              font-size: 16px;

            }
        }

        .button-grp{
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 20px;
            width: 100%;
            margin: 20px 0;
        }
    }
`
const PortalMemberRejectedReasonModal = () => {
  const { modalLocation} = useSelector(state => state.modal)

  const {portalMemberData, isLoadingApproveDraft} = useSelector(state => state.admin3)
  const { lockScroll, unlockScroll } = useScrollLock();

  const [reasonForRejection, setReasonForRejection] = useState("")

  const dispatch = useDispatch()
  const location = useLocation()

           //! bu modal açıldığnda ekran ı lock lamak için
           useEffect(() => {
            lockScroll()
    
            return () => {
                unlockScroll()
            }
        }, [lockScroll, unlockScroll])
    
        //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
        useEffect(() => {
            if (location.pathname !== modalLocation) {
                dispatch(showModal(null))
            }
        }, [dispatch, location.pathname, modalLocation])


  return (
    <Container onClick={()=> dispatch(showModal(null))}>
      <div className="modal" onClick={(e)=> e.stopPropagation() }>
        <p>Kamyoon portala <span className="red">{portalMemberData?.yetkiliUserName || "???"}</span> tarafından yapılan başvuruyu neden reddetiğinizi, isterseniz not düşebilirsiniz</p>

        <InputTextarea data={reasonForRejection} setData={(e) => setReasonForRejection(e.target.value)} name="reasonForRejection" inputWidth={"480px"} labelText={"Reddetme Nedeni"}/>

        <div className="button-grp">
            <Btn width={"225px"} bgColor="#E85446" color="#fff" handleClick={() => dispatch(approveRegisterDraft({id: portalMemberData?.id, isApproved: false, reasonForRejection: reasonForRejection }))}>{isLoadingApproveDraft ? <SmallSpinner size={"20px"} color={"#E85446"} bgColor={"#fff"}/> : "Reddet"}</Btn>
            <Btn width={"225px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showModal(null))}>Geri</Btn>
        </div>
      </div>
    </Container>
  )
}

export default PortalMemberRejectedReasonModal